import React, { Component } from "react";
import Moment from "react-moment";

class InfoBox extends Component {
  render() {
    const { info } = this.props;
    return (
      <div className="details">
          <p className="btn-order" style={{ height: "auto" }}><span className="t1"><Moment format="YYYY/MM/DD HH:mm">{info.create_time}</Moment></span><br />
              <span className="t2">{info.function}</span></p>
          <div className="collapse show">
              <p>{info.desc}</p>
          </div>
      </div>
    );
  }
}

export default InfoBox;
